<template>
  <aside class="main-sidebar">

    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">

      <!-- Sidebar user panel (optional) -->
      <div class="user-panel">
        <div class="pull-left image">
          <i class="fas fa-user"></i>
        </div>
        <div class="pull-left info">
          <div>
            <p class="white username">{{ displayName }}</p>
          </div>
          <a href="javascript:;" id="status"  v-if="this.$store.state.online"> 
          		<i class="fa fa-circle text-success"></i> Online
          </a>
          <a href="javascript:;" id="status" v-if="!this.$store.state.online"> 
          		<i class="fa fa-circle text-danger"></i> Offline
          </a>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <sidebar-menu />
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
/* eslint-disable */
import SidebarMenu from './SidebarMenu'
import axios from "axios";

export default {
    name: 'Sidebar',
    props: ['displayName'],
    components: { SidebarMenu },
    data: function () {
        return {
        	onlineState: this.isOnline(),
        	token: window.localStorage.getItem('token'),
        	estaSincronizando: false
       	}
    },
    mounted: function() {
    window
      .jQuery('[data-toggle="hideseek"]')
      .off()
      .hideseek()
    },
    created () {
      this.$on('online', function () {
            this.onlineState = true
      })
      this.$on('offline', function () {
            this.onlineState = false
      })
      this.interval = setInterval(() => this.isOnline(), 7000)
    },
    methods: {
    	isOnline() {
			let vm = this
	    	axios.get('https://images.sima-api.com/image-handler/img/sima-api/favicon-16x16.png?timestamp=' + new Date().getTime())
    		.then(function (response) {
    			vm.$store.commit('SYNC_ONLINE', true)
    			if (!vm.estaSincronizando) {
    				vm.estaSincronizando = true
    				vm.syncAPI()
    			}
            }).catch(function (error) {
            	vm.$store.commit('SYNC_ONLINE', false)
            })
	    },
	    syncAPI () {
	    	this.onlineState = true
			var vm = this
			var api = []
			api['producto'] = 'shaleproductos'
			api['movimiento'] = 'shaleregistros'
			api['etiqueta'] = 'shaleetiquetas'
					
        	db.allDocs({
    			include_docs: true
    		}).then(function(response) {
				if( response.rows.length > 0 ) { 
					let toast = vm.$toasted.show("Sincronizando datos. Por favor espere.", { 
                		icon : 'sync',
               		 	theme: "primary", 
                		position: "top-center", 
                		duration : 5000
                	});
                	
        			for (var i = 0; i < response.rows.length; i++) {
    					var id = response.rows[i].doc._id.toString()
    					var asset = response.rows[i].doc.asset.toString()
    					switch(response.rows[i].doc.accion) {
    						case 'add':
    							vm.addAPI(response.rows[i].doc, api)
    							break
    						case 'edit':
    							vm.editAPI(response.rows[i].doc, api)
    							break
    						case 'delete':
    							vm.removeAPI(response.rows[i].doc, api)
    							break
    					}
    					db.get(id).then(function(doc) {
    						return db.remove(doc)
    					})
    					.then(function (response) {
    		    			console.log('elimino')
    		    			vm.estaSincronizando = false
    		            }).catch(function (error) {
    			           alert('Error: ' + error)
    		            })
     				}
    				if (response.rows.length > 0) {
    					setTimeout(
    						function() {
            					vm.$store.commit('SYNC_PENDIENTES', 'etiquetas')
            					vm.$store.commit('SYNC_PENDIENTES', 'productos')
            					vm.$store.commit('SYNC_PENDIENTES', 'movimientos')
            					vm.estaSincronizando = false
    						}
    					, 5000)
    				}
				} else {
					vm.estaSincronizando = false
				}
 			}).catch(function(error) {
    			console.log(error)
    			vm.estaSincronizando = false
    		})
	    },
	    addAPI (item, api) {
        	var tipo = item.asset
			delete item._id;
    		delete item.asset;
    		axios.post('https://data.sima-api.com/' + api[tipo], item, {headers: {
    	    		Authorization: 'Bearer ' +  this.token
    		 	}
    		})
    	},
    	editAPI (item, api) {
    		var id = item._id
    		var tipo = item.asset
    		delete item._id;
    		delete item.asset;
    		axios.put('https://data.sima-api.com/' + api[tipo] + '/' + id, item, {headers: {
    	    		Authorization: 'Bearer ' +  this.token
    		 	}
    		})
    	},
    	removeAPI (item, api) {
    		var id = item._id
    		axios.put('https://data.sima-api.com/' + api[item.asset] + '/' + id, {Archivar: 'true'}, {headers: {
    	    		Authorization: 'Bearer ' +  this.token
    		 	}
    		})
    	}    
    }
}

</script>
<style scope="local">
.user-panel .image img {
  border-radius: 50%;
}
#searchForm {
  padding-left: 0em;
  padding-right: 0em;
}
#searchContainer {
  height: 100%;
  padding-bottom: 0em;
}
#search {
  width: 80%;
  float: right;
}

#search-btn {
  width: 20%;
}
.skin-red .main-header .logo {
    background-color: #222D32;
}
.skin-red .main-header .logo:hover{
    background-color: #222D32;
}
.fa-user{
    color: white;
    font-size: 26px;
    margin: 6px auto;
}
.user-panel>.info {
    left: 35px;
}
.user-panel>.info>a, .username {
    font-size: 14px;
}
.username {
    font-size: 16px;
}
.user-panel{
    height: 5em;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?78195674